import { useTracking } from 'react-tracking';
import {
  Heading,
  Box,
  Alert,
  AlertAction,
  useMount,
  Text,
} from '@simplywallst/ui-core';
import If from '@/components/If';
import { HoldingsTableLoading } from '../../../../components/HoldingsTable';
import { PortfolioPageHeader } from '../../../../components/PortfolioPageHeader';
import { PortfolioOverviewLoadingState } from '../../../../components/PortfolioOverview';

import type { Portfolio } from '@/hooks/portfolio/usePortfolio';

type Props = {
  portfolio: Portfolio;
};

const SharesightEmailNotConfirmedAlert = () => {
  const { trackEvent } = useTracking({
    type: 'track',
    modifier: 'SharesightEmailNotConfirmedAlert',
  });
  return (
    <Alert
      styleType="negative"
      data-cy-id="alert-sharesight-email-not-confirmed"
      actions={
        <AlertAction
          onClick={() => {
            trackEvent({
              action: 'click',
            });
          }}
        >
          Ok
        </AlertAction>
      }
    >
      <Text typography="small">
        Please log in at <a href="https://sharesight.com">sharesight.com</a> to
        continue connecting your account.
      </Text>
    </Alert>
  );
};

export const LinkingErrorState = ({ portfolio }: Props) => {
  const { Track, trackEvent } = useTracking({
    type: 'track',
    modifier: 'linkingErrorState',
  });

  useMount(() => {
    trackEvent({ action: 'landed' });
  });

  return (
    <Track>
      <PortfolioPageHeader
        portfolio={portfolio}
        templateRows="auto"
        templateColumns="auto min-content"
        templateColumnsMd="auto auto"
        justifyContentMd="space-between"
      />
      <section>
        <Box marginY="x2" marginXLg="x0" marginX="x2">
          <If
            conditions={{
              sharesightEmailNotConfirmed:
                portfolio.link.status === 'email_not_confirmed',
            }}
          >
            {{
              sharesightEmailNotConfirmed: () => (
                <SharesightEmailNotConfirmedAlert />
              ),
            }}
          </If>
        </Box>
        <PortfolioOverviewLoadingState />
      </section>
      <section>
        <Box marginY="x2" marginXLg="x0" marginX="x2">
          <Heading as="h2" typography="baseStrong">
            Holdings
          </Heading>
        </Box>
        <HoldingsTableLoading />
      </section>
    </Track>
  );
};
